// src/lib/geocode.js
import { httpNoAuth } from '../lib/httpNoAuth';

export async function geocodeAddress(address) {
  const { data } = await httpNoAuth.get('/api/utils/geocode/', { 
    params: { q: address },
    });
  if (data?.status?.code !== 200) {
    throw new Error(`Geocode error ${data.status.code}: ${data.status.message}`);
  }
  return data;
}
